<template>
  <component :is="completionComponent" :userId="userId" :dialogId="dialogId" :metadata="metadata"
    @newChatRequest="$emit('newChatRequest')" />
</template>

<script>
import { ref, watch } from 'vue';
import ChatFinishedStats from './ChatFinishedStats.vue';
import BackgroundCollectionComplete from './BackgroundCollectionComplete.vue';
import AssessmentComplete from './AssessmentComplete.vue';
import LessonComplete from './LessonComplete.vue';

export default {
  name: 'DialogCompletion',
  components: {
    ChatFinishedStats,
    BackgroundCollectionComplete,
    AssessmentComplete,
    LessonComplete
  },
  props: {
    userId: String,
    dialogId: String,
    metadata: {
      default: () => ({})
    }
  },
  emits: ['newChatRequest'],

  setup(props) {
    const completionComponent = ref('ChatFinishedStats');

    const getCompletionComponent = (type) => {
      console.log("getCompletionComponent", type);
      if (!type) return 'ChatFinishedStats';

      const completionComponents = {
        'FREESTYLE_CHAT': 'ChatFinishedStats',
        'COURSE_BACKGROUND': 'BackgroundCollectionComplete',
        'COURSE_ASSESSMENT': 'AssessmentComplete',
        'LESSON': 'LessonComplete',
      };

      return completionComponents[type] || 'ChatFinishedStats';
    };

    watch(() => props.metadata, (newMetadata) => {
      if (newMetadata) {
        completionComponent.value = getCompletionComponent(newMetadata.dialogType);
      }
    }, { immediate: true });

    return {
      completionComponent
    };
  }
};
</script>